const state = {
  // any type, we use it as boolean for now
  emSubscription: null
};

const getters = {
  hasEMSubscription: state => !!state.emSubscription
};

const mutations = {
  setEMSubscription(state, subscription) {
    state.emSubscription = subscription;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
